<template>
  <div class="transition
            duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110
            hover:opacity-100 hover:bg-white rounded-md">
      <button class="w-full my-2" @click="loadTeacherDashboard">
        <heading
        :user-name="teacher.name"
        :url-photo="teacher.urlProfilePhoto"
        :stars-avg="teacher.stars_avg"
        />
      </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Heading from '@/components/Heading.vue';

export default {
  components: {
    Heading,
  },

  props: ['teacher'],

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  methods: {
    ...mapActions({
      loadTeacher: 'teachers/getTeacher',
    }),

    loadTeacherDashboard() {
      // this.loadTeacher(this.id);
      this.$router.replace({ path: `/teachers/${this.teacher.slug}` });
    },
  },
};
</script>
